import React from 'react';
import {
  useAppDispatch,
  useAppSelector,
  type RootState,
} from '@/core/redux/store';
import { removeToast } from '@/core/redux/slices/toast-slice';
import { Toast } from '@/core/components/ui/Toast';

export const ToastProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const dispatch = useAppDispatch();
  const toasts = useAppSelector((state: RootState) => state.toast.items);

  const handleClose = (id: string) => {
    dispatch(removeToast(id));
  };

  return (
    <>
      {children}
      <div className='fixed top-[76px] right-5 flex flex-col gap-3 z-50'>
        {toasts.map((t) => (
          <Toast
            key={t.id}
            id={t.id}
            type={t.type}
            title={t.title}
            description={t.description || ''}
            onClose={() => handleClose(t.id)}
          />
        ))}
      </div>
    </>
  );
};

export { useToast } from './use-toast';
